// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__15hrp","messages":"Chat_messages__OESpZ","dateDivider":"Chat_dateDivider__xlbJ3"};